module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-box"
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "20px"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "7",
      "cy": "7",
      "r": "6",
      "fill": "transparent"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "18",
      "x2": "12",
      "y1": "18",
      "y2": "12"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, _vm.queryVenues]
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-208281de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchVenues.vue
// module id = 586
// module chunks = 0